<div class="flex flex-col">
  <span class="text-xs sm:text-sm font-normal pb-3">Media file uploading status:</span>

  <div class="flex flex-row w-full p-0.5 space-x-2" *ngFor="let file of mediaStateService.mediaUploading$ | async">
    <div class="flex flex-row items-center">
      <div class="flex min-w-1/5" *ngIf="file.fileStatus === 'Uploading'; else uploaded">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-3 h-3.5 sm:w-4 sm:h-4 text-gray-200 animate-spin">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
      </div>
      <ng-template #uploaded>
        <div class="flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-3 h-3.5 sm:w-4 sm:h-4" style="color: #0054A6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>
      </ng-template>
      <span class="flex w-4/5 text-xs sm:text-sm font-light ml-3"
        [ngStyle]="{color: file.fileStatus === 'Uploaded' ? '#0054A6' : '#4C4E50'}">{{file.fileStatus}}</span>
    </div>
    <div class="flex flex-1 flex-row w-3/5 sm:w-2/3">
      <span
        class="text-xs sm:text-sm font-light whitespace-nowrap overflow-hidden overflow-ellipsis">{{file.fileNameToDisplay}}.</span>
      <span class="text-xs sm:text-sm font-light">{{file.fileType}}</span>
    </div>
  </div>

  <!-- TESTING ONLY -->
  <!-- <div class="flex flex-row w-full p-0.5 space-x-2">
    <div class="flex flex-row items-center">
      <div class="min-w-1/5">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-3 h-3.5 sm:w-4 sm:h-4 text-gray-200 animate-spin">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
      </div>

      <span class="flex w-4/5 text-xs sm:text-sm font-light ml-3">Uploading</span>
    </div>
    <div class="flex flex-1 flex-row w-3/5 sm:w-2/3">
      <span class="flex text-xs sm:text-sm font-light">Diagnosis</span>
      <span class="flex text-xs sm:text-sm font-light">.png</span>
    </div>
  </div>

  <div class="flex flex-row w-full p-0.5 space-x-2">
    <div class="flex flex-row items-center">
      <div class="min-w-1/5">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-3 h-3.5 sm:w-4 sm:h-4 text-gray-200 animate-spin">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
      </div>

      <span class="flex w-4/5 text-xs sm:text-sm font-light ml-3" [ngStyle]="{color: '#0054A6' }">Uploaded</span>
    </div>
    <div class="flex flex-1 flex-row w-3/5 sm:w-2/3">
      <span
        class="text-xs sm:text-sm font-light whitespace-nowrap overflow-hidden overflow-ellipsis">Diagnosiswwwwwwwsdgdfgdfgdfgdfgdfgdfg</span>
      <span class="text-xs sm:text-sm font-light -ml-0.5 sm:-ml-1 ">png</span>
    </div>
  </div> -->
</div>